module.exports = "/_next/static/images/Hero@2x-b7495fe28a07e87fd8e9aa87b48c8082.png";